import SmartLaunchScreen from '@/src/auth/smartLaunchScreen';

export default SmartLaunchScreen;
